import _ from 'lodash';

export class UserService {
    static get(prop) {
        const user = localStorage.getItem('user');
        let parsedUser;

        try {
            parsedUser = JSON.parse(user);
        } catch (e) {
            parsedUser = {};
        }

        return _.isNil(prop) ? parsedUser : _.get(parsedUser, prop);
    }

    static set(user) {
        if (_.isNil(user)) return;

        localStorage.setItem('user', JSON.stringify(user));

        if (typeof window.FS !== 'undefined') {
            window.FS.identify(_.get(user, 'clientId'), {
                displayName: `${_.get(user, 'firstName')} ${_.get(user, 'lastName')}`,
                email: _.get(user, 'email')
            });
        }
    }
}
